import React, { useEffect, useState } from "react";
import SubjectTable from "./SubjectTable";
import { ProgressBar, Badge } from "react-bootstrap";

const SubjectTablePage = ({ id }) => {
  const [subjects, setSubjects] = useState([]);
  const [loadingSubjects, setLoadingSubjects] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, per_page: 10, pages: 1, total: 0 });

  const fetchSubjects = async (page = 1) => {
    
    setLoadingSubjects(true);
    try {
      const res = await fetch(`https://plo.areez.co/api/program/subject/clo_average?program_id=${id}&last_n=1&page=${page}&per_page=10`);
      const json = await res.json();
        console.log(subjects);
      setSubjects(json.subjects);
      setPagination({
        page: json.page,
        per_page: json.per_page,
        total: json.total_subjects,
        pages: Math.ceil(json.total_subjects / json.per_page),
      });
    } catch (err) {
      console.error("خطأ في جلب المقررات:", err);
    } finally {
      setLoadingSubjects(false);
    }
  };

  useEffect(() => {
    fetchSubjects();
  }, [id]);

  const handlePageChange = (newPage) => {
    fetchSubjects(newPage);
  };

  const columns = [
    { label: "#", field: "index" },
    // { label: "id", field: "subject_id" },
    { label: "رمز المقرر", field: "subject_code" },
    { label: "اسم المقرر", field: "subject_name" },
    // { label: "العام الأكاديمي", field: "academic_year" },
    // { label: "عدد الطلاب", field: "student_count" },
    { label: "تحقيق CLO", field: "achievement_display" },
    { label: "عمليات", field: "actions" },

  ];

  const programs = subjects.map((subject, idx) => {
    const year = Object.keys(subject.achievement_by_year)[0];
    const data = subject.achievement_by_year[year];

    return {
      index: idx + 1 + (pagination.page - 1) * pagination.per_page,
      subject_code: subject.subject_code,
      subject_id:subject.subject_id,
      program_id:id,
      subject_name: subject.subject_name,
      academic_year: year,
      student_count: data.student_count,
      achievement_display: (
        <>
          <div className="mb-1">
            <ProgressBar
              now={data.average_clo_achievement}
              variant="primary"
              style={{ height: "6px" }}
            />
          </div>
          <Badge variant="primary light">
            {data.average_clo_achievement.toFixed(2)}%
          </Badge>
        </>
      ),
    };
  });

  return (
    <>
      {loadingSubjects ? (
        <p className="text-center">جاري تحميل المقررات...</p>
      ) : (
        <SubjectTable
          title="مقررات البرنامج"
          data={programs}
          columns={columns}
          pagination={pagination}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
};

export default SubjectTablePage;
